export default __webpack_public_path__ + "static/messi-xs-a844910fa2141a8bed747ad5002db670.png";